export function handleUnauthorized({
  storage = globalThis.localStorage,
  location = globalThis.location,
  clearAuthCache,
  loginPath = '/login',
} = {}) {
  storage?.removeItem('authToken');
  clearAuthCache?.();

  if (location && !String(location.pathname || '').endsWith(loginPath)) {
    location.replace(loginPath);
  }
}
